// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore, collection, query, where, getDocs } from 'firebase/firestore';

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDm2lFj5lqN3lWD259ILBvzvdLi9Gqjrlo",
  authDomain: "iparking-55511.firebaseapp.com",
  projectId: "iparking-55511",
  storageBucket: "iparking-55511.firebasestorage.app",
  messagingSenderId: "54670957143",
  appId: "1:54670957143:web:7c516668c6ebfd29726112",
  measurementId: "G-DENY2FRQ7H"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

export const db = getFirestore(app);